module.exports = __webpack_public_path__ + "assets/img/image-upload-logo.557edcf3.svg";